<template>
  <div>
    <Dialog header="Errors" :visible.sync="viewDialog" :style="{width: '700px'}" :modal="true"> 
        <!-- :life="msg.life" -->
      <Message 
        v-for="(msg, index) of messages" 
        :key="index"
        :severity="msg.severity"
        :closable="false"
      >{{msg.content}}</Message>
      <template #footer>
        <Button
          @click="$emit('clearAllErrors')"
          label="Clear All Errors"
          class="p-button-danger"
          style="float:left;"
        />
        <Button label="Ok" icon="pi pi-check" @click="$emit('close')" class="p-button-text" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    'viewDialog',
    'messages'
  ]
}
</script>

<style>

</style>